<div class="myvf-custom-error" *ngIf="show">
  <img *ngIf="imageUrl" [src]="imageUrl">
  <div class="message">
    {{customMessage}}
  </div>
</div>
